import { clickoutUrl } from '~/components/deal/clickout-url'
import { useAppContext } from '~/contexts/app-context'
import { useEcommerceContext } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'

export const useClickoutUrl = ({ deal, list, position, placementType, title }) => {
  const { cookies, device } = useAppContext()
  const { pageId, path } = usePageContext()
  const { data, getImpressionId } = useEcommerceContext()

  const { comparisonId, currentProvider, postcode, sort, uprn } = data

  return clickoutUrl({
    pageId,
    page: path,
    deal,
    ecommerce: { comparisonId, impressionId: getImpressionId(deal.id) },
    position,
    list: list || data.list,
    currentProvider,
    postcode,
    placementType,
    sort,
    device,
    uprn,
    sskey: cookies.sskey,
    title
  })
}
